import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Colored from '../../../../UI/Headline/Colored'
import Loading from '../../../../UI/Loading/Loading'
import Create from './Create/Create'
import useConceptConfiguration from '../ConceptCalculation/useConceptConfiguration'
import DNDList from '../../../../UI/DNDList/DNDList'
import SingleConcept from './SingleConcept/SingleConcept'

const ManageConcepts: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { concepts, activeConceptUUID, updateConceptOrder } = useConceptConfiguration()

  return (
    <div className="flex flex-col gap-3 justify-between">
      <Colored text={t.survey.analysis.concept.create.title} />
      <Loading loading={concepts} />
      <Create />
      {Array.isArray(concepts) && (
        <div className="flex flex-col gap-3">
          {concepts.length > 0 && (
            <DNDList
              orderUpdateCallback={updateConceptOrder}
              items={concepts.map((concept) => {
                const isActive = concept.uuid === activeConceptUUID
                return {
                  id: concept.uuid,
                  data: concept,
                  content: <SingleConcept isActive={isActive} concept={concept} />,
                }
              })}
            />
          )}
          {concepts.length === 0 && <div className="text-gray text-sm">{t.survey.analysis.concept.empty}</div>}
        </div>
      )}
    </div>
  )
}

export default ManageConcepts
